<template>
  <div class="row">
    <div class="col-12">
      <breadcrumb :page="page" @page-change="page = $event" />
    </div>
    <div class="col-12 flip-cards-container">
      <squareOption
        v-for="(option, index) in optionList"
        :key="index"
        :option="option"
      />
    </div>
  </div>
</template>

<script>
import store from '@/modules/app/store/index';
import { name as userModuleName } from '@/modules/user/store';
import squareOption from '@/components/common/menu/SquareOption';
import breadcrumb from '@/components/common/page/TitleBreadcrumb';
import navMenuTitles from '@/utils/constants/navMenuTitles';

import { mapState } from 'vuex';

export default {
  components: {
    squareOption,
    breadcrumb,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-city',
        title: 'Proceso de Competencias',
        routes: ['Proceso de Competencias'],
      },
    };
  },
  computed: {
    ...mapState(userModuleName, ['userMenu']),
    hasSelectedStudent() {
      return store.getters.IsValidSelectedStudent;
    },
    optionList() {
      return this.userMenu
        .find((x) => x.title === navMenuTitles.ProcesoCompetencia)
        .children.map((item) => ({
          title: item.title,
          description: item.description,
          detail: item.detail,
          icon: item.iconClasses,
          mainImage: item.mainImagePath,
          hoverImage: item.mainImageHoverPath,
          needSelectedStudent: item.needSelectedStudent,
          route: item.navigationPath,
        }));
    },
  },
};
</script>
